import { jsx } from '@emotion/core';
export default ({ fit, children, ...rest }) => (jsx("span", Object.assign({ css: {
        alignSelf: 'center',
        display: 'inline-flex',
        flexWrap: 'nowrap',
        maxWidth: '100%',
        position: 'relative',
        ...(fit && { width: '100%' }),
        ...(fit && { justifyContent: 'center' }),
    } }, rest), children));
//# sourceMappingURL=InnerWrapper.js.map